import { useQuery } from 'react-query'
import { QUERY_KEYS } from '~api'

export const useLoadUserCompetitors = (brand, onSuccess) => {
  return useQuery([QUERY_KEYS.USER_COMPETITORS, brand], {
    enabled: !!brand,
    onSuccess,
  })
}
